import React, { useEffect } from 'react';
import type { ITablaClientesVistaProps } from '../interfaces';
import Tabla from '../../../globales/componentes/tabla/tabla';
import { ActionIcon, Group, Tooltip } from '@mantine/core';
import { IconFilter, IconFilterFilled, IconRefresh } from '@tabler/icons-react';
import { Box } from '@mui/material';
import FiltroClientesVista from './filtroClientesVista';

const TablaClientesVista: React.FunctionComponent<ITablaClientesVistaProps> = ({
  tabla,
  consultarClientes,
  filtro,
  manejarHabilitarFiltros,
  habilitarFiltros,
  manejarCambioFiltroCliente,
  indicePagina,
  TAMANIO_PAGINA
}) => {

  useEffect(() => {
    consultarClientes(tabla.getState().pagination.pageIndex, tabla.getState().pagination.pageSize);
  }, [])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
      {/* Cabezal de Filtros y Botones */}
      <div style={{ marginBottom: '10px' }}>
        <Group justify="space-between" w="100%">
          <Box style={{ flex: 1, minWidth: 0 }}>
            {habilitarFiltros && (
              <FiltroClientesVista
                consultarClientes={() => consultarClientes(indicePagina, TAMANIO_PAGINA)}
                filtro={filtro}
                manejarCambioFiltroCliente={manejarCambioFiltroCliente}
              />
            )}
          </Box>
          <Group gap={4}>
            <Tooltip
              label="Refrescar"
              withinPortal
              openDelay={100}
              zIndex={9999}
              style={{ fontSize: '10px', padding: '3px 5px' }}
            >
              <ActionIcon
                variant="subtle"
                color="primary"
                radius="xl"
                onClick={() => consultarClientes(indicePagina, TAMANIO_PAGINA)}
              >
                <IconRefresh size={16} />
              </ActionIcon>
            </Tooltip>
            <Tooltip
              label="Filtrar"
              withinPortal
              openDelay={100}
              zIndex={9999}
              style={{ fontSize: "10px", padding: '3px 5px' }}
            >
              <ActionIcon
                variant="subtle"
                color="primary"
                radius="xl"
                onClick={() => manejarHabilitarFiltros(!habilitarFiltros)}
              >
                {habilitarFiltros ? <IconFilterFilled size={16} /> : <IconFilter size={16} />}
              </ActionIcon>
            </Tooltip>
          </Group>
        </Group>
      </div>
      <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <Tabla
          tabla={tabla}
        />
      </div>
    </div>
  );
};

export default TablaClientesVista;
